import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="theme"
export default class extends Controller {
    static targets = ["toggle"]

    connect() {
        const savedTheme = localStorage.getItem("bs-theme")
        if (savedTheme) {
            document.documentElement.setAttribute("data-bs-theme", savedTheme)
            this.updateToggleText(savedTheme)
        } else {
            const current = document.documentElement.getAttribute("data-bs-theme") || "light"
            this.updateToggleText(current)
        }
    }

    switch(event) {
        event.preventDefault()
        const theme = event.currentTarget.dataset.theme
        console.log(theme)
        document.documentElement.setAttribute("data-bs-theme", theme)
        localStorage.setItem("bs-theme", theme)
        this.updateToggleText(theme)
    }

    toggle(event) {
        event.preventDefault()
        const current = document.documentElement.getAttribute("data-bs-theme") || "light"
        const next = current === "light" ? "dark" : "light"
        document.documentElement.setAttribute("data-bs-theme", next)
        localStorage.setItem("bs-theme", next)
        this.updateToggleText(next)
    }

    updateToggleText(theme) {
        if (this.hasToggleTarget) {
            this.toggleTarget.textContent = theme === "light" ? "Темная тема" : "Светлая тема"
        }
    }
}